module.exports = __webpack_public_path__ + "static/scale-model-of-great-plains-art-museum-in-lincoln-nebraska-9d6ed828c37f2720534309a312af588c.png";